import { loadStripe } from "@stripe/stripe-js";

// Initialize Stripe with publishable key
// This is safe to expose in client-side code
const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

export const stripePromise = loadStripe(publishableKey);
